import React from 'react';
import { useFilterContext } from '../../context/filter_context';
import { useLanguageContext } from '../../context/language_context';
import { BsFillGridFill, BsList } from 'react-icons/bs';
import { SlidersHorizontal, ChevronDown } from 'lucide-react';
import Wrapper from './styles';

const Sort = ({ onMobileFilterClick, activeFilterCount = 0 }) => {
  const { t, isArabic } = useLanguageContext();
  const {
    filtered_products: products,
    grid_view,
    sort,
    setGridView,
    setListView,
    updateSort,
  } = useFilterContext();

  return (
    <Wrapper style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <div className='toolbar-left'>
        {/* Mobile Filter Button */}
        <button 
          type='button'
          className='mobile-filter-btn'
          onClick={onMobileFilterClick}
        >
          <SlidersHorizontal size={16} />
          <span>{t.products?.filters || 'Filtres'}</span>
          {activeFilterCount > 0 && (
            <span className='filter-badge'>{activeFilterCount}</span>
          )}
        </button>

        {/* Mobile Sort Dropdown - Compact "Trier" */}
        <div className='mobile-sort-container'>
          <select
            name='sort'
            id='mobile-sort'
            className='mobile-sort-select'
            value={sort}
            onChange={updateSort}
          >
            <option value='newest'>{t.products?.sortBy || 'Trier'}: {t.products.newest}</option>
            <option value='price-lowest'>{t.products?.sortBy || 'Trier'}: {t.products.lowestPrice}</option>
            <option value='price-highest'>{t.products?.sortBy || 'Trier'}: {t.products.highestPrice}</option>
            <option value='name-a'>{t.products?.sortBy || 'Trier'}: {t.products.nameAZ}</option>
            <option value='name-z'>{t.products?.sortBy || 'Trier'}: {t.products.nameZA}</option>
          </select>
          <ChevronDown size={14} className='sort-chevron' />
        </div>

        <p className='product-count'>
          <span>{products.length}</span> {t.nav.products}
        </p>
      </div>

      <div className='toolbar-right'>
        {/* Desktop Sort Dropdown */}
        <div className='sort-container'>
          <label htmlFor='sort' className='sort-label'>{t.products.sortBy}</label>
          <select
            name='sort'
            id='sort'
            className='sort-input'
            value={sort}
            onChange={updateSort}
          >
            <option value='newest'>{t.products.newest}</option>
            <option value='price-lowest'>{t.products.lowestPrice}</option>
            <option value='price-highest'>{t.products.highestPrice}</option>
            <option value='name-a'>{t.products.nameAZ}</option>
            <option value='name-z'>{t.products.nameZA}</option>
          </select>
        </div>

        {/* View Mode Toggle */}
        <div className='btn-container'>
          <button
            type='button'
            className={`${grid_view ? 'active' : null}`}
            onClick={setGridView}
          >
            <BsFillGridFill />
          </button>
          <button
            type='button'
            className={`${!grid_view ? 'active' : null}`}
            onClick={setListView}
          >
            <BsList />
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

export default Sort;
